import gql from "graphql-tag";

export const GET_FULL_FEATURE = gql`
  query GetFullCostumeFeatureInventories($filters: FeatureInvInput) {
    getFullCostumeFeatureInventories(filters: $filters) {
      content {
        presentation {
          id
          name
        }
        id
        name
        isCommon
      }
    }
  }
`;
